import { HeroCard } from 'components/HeroCard';
import { PlaceholderHeroCard } from 'components/PlaceholderHeroCard';
import { useListEngagementData } from 'components/SnowplowEngagementAnalytics/hooks';
import { AnalyticsContextProvider } from 'contexts/AnalyticsContext';
import { Observable as ImpressionObservable } from 'contexts/ImpressionAnalyticsContext/Observable';
import { useCards } from 'hooks/useCards';
import * as React from 'react';
import { getCardKey } from 'utils/card';
import { idFromPointer } from 'utils/pointer';
import { ListLayoutProps } from '../ListLayoutProps';
import { ListNotifications } from '../ListNotifications';

const PAGE_SIZE = 1;

export const HeroList: React.FunctionComponent<ListLayoutProps> = ({
  index,
  list,
  listKey,
}) => {
  const { cards, loading, notifications, meta } = useCards({
    source: list.source,
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });
  const groupEngagementData = useListEngagementData({
    cardPageMeta: meta,
    isPaginated: false,
    list,
    listIndex: index,
  });

  return (
    <AnalyticsContextProvider context={meta?.analytics?.context?.comscore}>
      <ListNotifications listStyle={list.style} notifications={notifications} />

      {cards.map((card, index) => {
        const key = getCardKey(card, listKey);

        return (
          <ImpressionObservable
            key={key}
            yleId={idFromPointer(card.pointer) || undefined}
            itemPosition={index}
          >
            <HeroCard
              card={card}
              cardKey={key}
              groupEngagementData={groupEngagementData}
              key={key}
              imageAspectRatio={list.style?.image}
            />
          </ImpressionObservable>
        );
      })}

      {loading && <PlaceholderHeroCard imageAspectRatio={list.style?.image} />}
    </AnalyticsContextProvider>
  );
};
